import React, { useEffect, useState, useRef, useContext } from "react";
import Navbar from "../../components/Navbar/Navbar";

// asstes
import outputArrow from "../../assets/images/outputArrow.svg";
import chatLogo from "../../assets/images/chatLogo.svg";
import { useTranslationContext } from "../../contexts/TranslationContext";
import clearChat from "../../assets/images/clearChat.svg"
import { postShowFeedback, fetchQueryCard } from "../../store/apiActions";
import FeedbackPopup from "../../components/Feedback/Feedback";
import MessageComponent from "../../components/Citation";
import PdfPreview from "../../components/Preview/Preview";
import trash from "../../assets/images/trash.svg"
import useStartSession from "../../hooks/useStartSession";
import clearChatDark from "../../assets/images/clearChatDark.svg";
import dropDownIcon from "../../assets/images/dropDownIcon.svg";
import { ThemeContext } from "../../contexts/ThemeContext";
import { encrypted } from "../../utils/Utility";
import { clearLocalStoragePreservingTheme } from '../../utils/Utility.jsx';
import PromptExamplesModal from "../../components/Prompt/Prompt.jsx";

import { postFeedback, postCommentFeedback } from "../../store/apiActions";
import like from "../../assets/images/like.svg";
import dislike from "../../assets/images/dislike.svg"
import likeSelected from "../../assets/images/likeSelected.svg";
import dislikeSelected from "../../assets/images/dislikeSelected.svg";
import likeDark from "../../assets/images/likeDark.svg";
import dislikeDark from "../../assets/images/dislikeDark.svg"
import likeSelectedDark from "../../assets/images/likeSelectedDark.svg";
import dislikeSelectedDark from "../../assets/images/dislikeSelectedDark.svg";
import { useNavigate } from "react-router-dom";

import "./Chat.css";
import { env } from "../../environment";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useDispatch } from "react-redux";
const Chat = () => {
  const startSession = useStartSession();
  const navigate = useNavigate();
  const [isCardsLoading, setIsCardsLoading] = useState(false);
  const [userInput, setUserInput] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const { translations } = useTranslationContext();
  const [showFeedback, setShowFeedback] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [isFeedbackPopupClosed, setIsFeedbackPopupClosed] = useState(false);
  const [selectedFeedback, setSelectedFeedback] = useState({});
  const [isTypingFeedback, setIsTypingFeedback] = useState(false);
  const [openDoc, setOpenDoc] = useState(false);
  const [feedbackData, setFeedbackData] = useState({});
  const [queries, setQueries] = useState([]);
  const [showClearChatModal, setShowClearChatModal] = useState(false);
  const closeModal = () => setOpenDoc(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const openModal = () => setOpenDoc(true);
  const [responses, setResponses] = useState([]);
  const [showFeedbackInput, setShowFeedbackInput] = useState(false);
  const [submittingFeedback, setSubmittingFeedback] = useState(false);
  const [currentFeedbackIndex, setCurrentFeedbackIndex] = useState(null);
  const [citationModalContent, setCitationModalContent] = useState(null);
  const [userName, setUserName] = useState("");
  const [feedbackInput, setFeedbackInput] = useState("");
  const clearChatText = translations["clear_chat_text"] || "Clear Chat";
  const commandText = translations["command"] || "Enter = Search and Shift+Enter = New Line";
  const chatWelcomeText = translations["chat_welcome"] || "Introducing ChatNPP!";
  const chatIntroText = translations["chat_intro"] || "Designed to support your work by providing expert information and answering questions related specifically to NPP products. With deep expertise in agronomy and a strong connection to the commercial and marketing teams, my goal is to deliver concise, actionable insights to positively impact customer retention 🌱📈.";
  const descriptionText = translations["description_text"] || "Get started with ChatNPP";
  const expertiseTitleText = translations["expertise_title"] || "Areas of Expertise";
  const nppProductsText = translations["NPP Products"] || "NPP Products";
  const agriculturalBiotechnologyText = translations["Agricultural Biotechnology"] || "Agricultural Biotechnology";
  const microbiologyText = translations["Microbiology"] || "Microbiology";
  const viewMore = translations["view_more"] || "View more";
  const plantScienceText = translations["Plant Science"] || "Plant Science";
  const agronomyText = translations["Agronomy"] || "Agronomy";
  const soilScienceText = translations["Soil Science"] || "Soil Science";
  const environmentalScienceText = translations["Environmental Science"] || "Environmental Science";
  const feedbackSuccessText = translations["feedback_success"] || "Feedback submitted successfully";
  const feedbackFailureText = translations["feeback_failure"] || "Failed to submit feedback";
  const questionText = translations["question_prompt"] || "Enter a question";
  const feedbackPrompt = translations["feedback_prompt"] || "Additional feedback";
  const feedbackSubmit = translations["submit_feedback"] || "Press enter to submit";
  const promptExamplesText = translations["prompt_examples"] || "Prompt Examples";

  // Ref for the conversation container
  const conversationRef = useRef(null);
  const feedbackInputRef = useRef(null);
  const feedbackContainerRef = useRef(null);
  const pdfPreviewRef = useRef(null);
  const feedbackButtonsRef = useRef(null);
  const { isDarkMode } = useContext(ThemeContext);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [fileName, setFileName] = useState(null);
  const [showScrollButton, setShowScrollButton] = useState(false);
  const chatContainerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const scrollRef = useRef(null);

  const [capabilities, setCapabilities] = useState([]);
  const [isSample, setIsSample] = useState(false);
  const language = encrypted.getDecryptedItem("language") || "en";

  useEffect(() => {
    fetchCardsData();
  }, [translations]);

  const fetchCardsData = async () => {
      setIsCardsLoading(true);
      try {
        const queryParams = new URLSearchParams({ language });
        const response = await dispatch(fetchQueryCard(
          `${env.baseURL}/get-example-queries?${queryParams}`,
        ));
        if (Array.isArray(response)) {
          setCapabilities(response);
        } else if (response?.encryptedBody) {
          const decryptedData = JSON.parse(
            encrypted.decrypt(response.encryptedBody)
          );
          setCapabilities(decryptedData);
        } else {
          console.warn("Unexpected response format:", response);
        }
      } catch (error) {
        console.error("Error fetching example queries:", error);
      }
      setIsCardsLoading(false);
    };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const handleScroll = () => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) return;

    const cardWidth = scrollElement.scrollWidth / 4;
    const index = Math.round(scrollElement.scrollLeft / cardWidth);
    setActiveIndex(index);
  };

  useEffect(() => {
    const scrollElement = scrollRef.current;
    if (!scrollElement) return;

    scrollElement.addEventListener('scroll', handleScroll);
    return () => scrollElement.removeEventListener('scroll', handleScroll);
  }, []);

  const dispatch = useDispatch();
  const [feedbackButtonsDisabled, setFeedbackButtonsDisabled] = useState(() => {
    const savedDisabled = encrypted.getDecryptedItem("feedbackButtonsDisabled");
    return savedDisabled && savedDisabled !== "undefined" ? savedDisabled : {};
  });

  useEffect(() => {
    try {
      const decrypted = encrypted.decrypt(localStorage.getItem("LoggedInDetails"));
      const parsedDetails = JSON.parse(decrypted);
      if (parsedDetails.full_name) {
        setUserName(parsedDetails.full_name.split(" ")[0]);
      }
    } catch (error) {
      console.error("Failed to parse user details from localStorage:", error);
    }
  }, []);

  const checkFeedbackPopup = async () => {
    let sessionData = encrypted.getDecryptedItem(
      "startSession");
    const userId = sessionData?.user_id || "";
    const sessionId = sessionData?.session_id || "";
    const requestBody = {
      user_id: userId,
      session_id: sessionId,
    };
    const url = `${env.baseURL}/check-feedback-popup`;

    try {
      const response = await dispatch(postShowFeedback(url, requestBody)); // Send encrypted body
      if (response) {
        setShowFeedback(true);
      }
    } catch (error) {
      console.error("Error checking feedback popup:", error);
      toast.error(error?.response?.data?.message || "Failed to check feedback popup.");
    }
  };

  useEffect(() => {
    let startSession = encrypted.getDecryptedItem(
      "startSession");
    if (!startSession) {
      console.warn("startSession is not set in localStorage");
      toast.error("Session data missing. Please refresh the chat.");
    }
  }, []);

  useEffect(() => {
    encrypted.setEncryptedItem(
      "feedbackButtonsDisabled", feedbackButtonsDisabled);
  }, [feedbackButtonsDisabled]);

  useEffect(() => {
    // Check if the page was reloaded
    if (performance.getEntriesByType("navigation")[0]?.type === "reload") {
      localStorage.removeItem("feedbackData");
      localStorage.removeItem("selectedFeedback");
      localStorage.removeItem("showFeedback");
      localStorage.removeItem("feedbackButtonsDisabled");
      localStorage.removeItem("queries");
      localStorage.removeItem("responses");
    }

    const savedFeedback = encrypted.getDecryptedItem(
      "feedbackData");
    if (savedFeedback) {
      setFeedbackData(savedFeedback);
    }

    // Load selectedFeedback
    const savedSelectedFeedback = encrypted.getDecryptedItem(
      "selectedFeedback");
    if (savedSelectedFeedback) {
      setSelectedFeedback(savedSelectedFeedback);
    }
    // Load showFeedback
    const savedShowFeedback = encrypted.getDecryptedItem(
      "showFeedback");
    if (savedShowFeedback !== undefined) {
      setShowFeedback(savedShowFeedback);
    }

    const savedQueries = encrypted.getDecryptedItem("queries");
    if (savedQueries) {
      setQueries(savedQueries);
    } else {
      setQueries([]);
    }

    const savedResponses = encrypted.getDecryptedItem("responses");
    if (savedResponses) {
      setResponses(savedResponses);
    } else {
      setResponses([]);
    }
  }, []);

  useEffect(() => {
    // Save specific values to local storage
    encrypted.setEncryptedItem(
      "feedbackData", (feedbackData));
    encrypted.setEncryptedItem(
      "selectedFeedback", (selectedFeedback));
    encrypted.setEncryptedItem(
      "showFeedback", (showFeedback));
    encrypted.setEncryptedItem(
      "queries", (queries));
    encrypted.setEncryptedItem(
      "responses", (responses));
  }, [feedbackData, selectedFeedback, showFeedback, queries, responses]);
  const handleCitationClick = (citation) => {
    setCitationModalContent(citation);
    setFileName(citation.title)
    setOpenDoc(true); // Open the PDF preview modal
  };

  const handleCloseCitationModal = () => {
    setOpenDoc(false);
    setCitationModalContent(null);
  };

  const handleInputChange = (e) => {
    const value = e.target.value;
    setUserInput(value);
    if (value.trim() === "") {
    setIsSample(false);
  }
  };

  const handleFeedback = async (index, type) => {
    if (selectedFeedback[index] !== type) { // Check if button is being switched
      setFeedbackInput((prevFeedback) => {
        const updatedFeedback = { ...prevFeedback };
        if (updatedFeedback[index]) {
          delete updatedFeedback[index]; // Clear the comment for that index
        }
        return updatedFeedback;
      });
      setFeedbackInput("");
    }
    setFeedbackData((prevFeedback) => ({
      ...prevFeedback,
      [index]: { type, comment: "" },
    }));
    setSelectedFeedback((prev) => ({
      ...prev,
      [index]: type,
    }));
    setCurrentFeedbackIndex(index);
    setShowFeedbackInput(type === "dislike"); // Show feedback input only for dislike
    // Disable buttons
    setFeedbackButtonsDisabled((prev) => ({ ...prev, [index]: true }));

    // Call the feedback API
    await handleFeedbackSubmit(index, type);
  };
  const handleFeedbackCommentChange = (event) => {
    const updatedComment = event.target.value;
    setFeedbackInput(prevFeedback => ({
      ...prevFeedback,
      [currentFeedbackIndex]: {
        ...prevFeedback[currentFeedbackIndex],
        comment: updatedComment,
      },
    }));
    setIsTypingFeedback(updatedComment.trim().length > 0);
  };

  const updateFeedbackComment = async (index) => {
    if (!feedbackInput[index]?.comment) {
      return; // Don't submit if there's no comment
    }
    try {
      let chatbotDetails = encrypted.getDecryptedItem(
        "chatbotDetails");
      const sessionData = encrypted.getDecryptedItem(
        "startSession") || {};
      const sessionId = sessionData?.session_id || "";
      const userId = sessionData?.user_id || "";
      const queryIndex = Math.floor(Number(index) / 2);
      const comment = feedbackInput[index]?.comment || "";

      let requestBody = {
        "user_id": userId,
        "session_id": sessionId,
        "temperature": chatbotDetails?.user_session?.temperature,
        "top_p": chatbotDetails?.user_session?.top_p,
        "search_index": chatbotDetails?.user_session?.search_index,
        "embedding_name": chatbotDetails?.user_session?.embedding_name,
        "search_strictness": chatbotDetails?.user_session?.search_strictness,
        "search_top_k": chatbotDetails?.user_session?.search_top_k,
        "max_tokens": chatbotDetails?.user_session?.max_tokens,
        "model_name": chatbotDetails?.user_session?.model_name,
        "api_version": chatbotDetails?.user_session?.api_version,
        "search_service": chatbotDetails?.user_session?.search_service,
        "tipo_chat": chatbotDetails?.user_session?.tipo_chat,
        "idioma_3l": chatbotDetails?.user_session?.idioma_3l,
        "language": chatbotDetails?.user_session?.language,
        "country": chatbotDetails?.user_session?.country,
        "queries": chatbotDetails?.user_session?.queries,
        "responses": chatbotDetails?.user_session?.responses,
        "feedback": chatbotDetails?.user_session?.feedback,
        "feedback_comment": comment,
        "message_index": queryIndex,
      };
      await dispatch(postCommentFeedback(`${env.baseURL}/update-feedback-chat-comment`, requestBody));
      toast.success(feedbackSuccessText);
      setFeedbackInput(prev => {
        const newFeedback = { ...prev };
        delete newFeedback[index];
        return newFeedback;
      });
      setShowFeedbackInput(false);
      setCurrentFeedbackIndex(null);
      setIsTypingFeedback(false);
      await new Promise((resolve) => setTimeout(resolve, 2400));
      setShowFeedbackInput(false);
    } catch (error) {
      console.error("Feedback submission error:", error);
      toast.error(feedbackFailureText);
    }
  };

  const handleSubmitQuery = async () => {
    if (showFeedbackInput && currentFeedbackIndex !== null && feedbackInput[currentFeedbackIndex]?.comment) {
      await updateFeedbackComment(currentFeedbackIndex);
    }
    let data = encrypted.getDecryptedItem(
      "startSession") || { queries: [], responses: [] };
    let country = encrypted.getDecryptedItem(
      "country");
    let language = encrypted.getDecryptedItem(
      "language");
    let selectedModel = encrypted.getDecryptedItem("selectedModel") || "GPT-4o";
    const sessionId = data?.session_id || "";
    const userId = data?.user_id || ""
    const token = localStorage.getItem('token');
    if (!sessionId) {
      toast.error("Session ID not found. Please reload the page and start again.");
      setIsLoading(false);
      return;
    }
    if (userInput.trim()) {
      const userMessage = {
        sender: "user",
        text: userInput,
      };
      const placeholderBotMessage = {
        sender: "assistant",
        text: '__loading__'
      };
      setIsLoading(true);
      setShowFeedback(false);
      setConversation((prevMessages) => [
        ...prevMessages,
        userMessage,
        placeholderBotMessage,
      ]);
      let pastQueries = data.queries || [];
      let pastResponses = data.responses || [];
      let allQueriesResponses = pastQueries.map((query, index) => ({
        query: query.body,
        response: pastResponses[index]?.body || "",
      }));

      allQueriesResponses.push({
        query: userInput,
        response: "",
      });

      let requestBody = {
        "query": userInput,
        "language": language,
        "country": country,
        "model_name": selectedModel,
        "user_id": userId,
        "session_id": sessionId,
        "sample": isSample,
      };
      setUserInput("");
      try {
        const response = await fetch(`${env.baseURL}/chatnpp-chatbot`, {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            encryptedBody: encrypted.encrypt(JSON.stringify(requestBody)),
          }),
        });

        if (!response?.ok) {
          const errorText = await response.text();
          let decryptedError = errorText;
          try {
            decryptedError = encrypted.decrypt(errorText);
          } catch (decryptedError) {
            console.warn("Failed to decrypt error message, showing raw text instead.");
          }
          if (response?.status === 401) {
            clearLocalStoragePreservingTheme();
            setTimeout(() => {
              navigate("/sign-in");
            }, 1500);
          }
          if (response?.status === 400 || response?.status === 403) {
            toast.error(`Error ${response.status}`);
          } else {
            toast.error(`Server error: ${response.status}`);
          }
          throw new Error(
            `Server error: ${response.status} - ${decryptedError}\n${decryptedError}`
          );
        }

        const encryptedResponse = await response?.json();
        const dataFromServer = JSON.parse(encrypted.decrypt(encryptedResponse.encryptedBody));

        if (!dataFromServer?.response) {
          throw new Error("Invalid response format from the server");
        }
        encrypted.setEncryptedItem(
          "chatbotDetails", dataFromServer);
        setIsLoading(false);
        const botResponseText = dataFromServer?.response?.bot?.body || "I'm not sure how to respond to that.";
        const citations = dataFromServer?.response?.bot?.lst_citation_dto || [];
        const totalTokens = dataFromServer?.response?.bot?.total_tokens ?? 0;
        const promptTokens = dataFromServer?.response?.bot?.prompt_tokens ?? 0;
        const completionTokens = dataFromServer?.response?.bot?.completion_tokens ?? 0;
        const responseTime = dataFromServer?.response?.bot?.response_time ?? 0;
        const disclaimerText = dataFromServer?.response?.disclaimer || "";
        const relevantLinks = dataFromServer?.response?.bot?.relevant_links || [];

        const responseMessage = {
          sender: "assistant",
          text: botResponseText,
          citations: citations,
          totalTokens: totalTokens,
          responseTime: responseTime,
          promptTokens: promptTokens,
          completionTokens: completionTokens,
          relevantLinks: relevantLinks,
          disclaimerText: disclaimerText,
        };
        setShowFeedbackInput(false);
        setCurrentFeedbackIndex(null);
        setFeedbackInput({});
        setShowFeedback(true);
        setConversation((prevMessages) => {
          const newMessages = [...prevMessages];
          newMessages[newMessages.length - 1] = responseMessage;
          return newMessages;
        });

        setQueries((prevQueries) => [...prevQueries, userInput]);
        setResponses((prevResponses) => [...prevResponses, botResponseText]);
        const updatedData = {
          ...data,
          queries: [...pastQueries, { body: userInput, is_request: true }],
          responses: [...pastResponses, { body: botResponseText, is_request: false }],
        };
        encrypted.setEncryptedItem(
          "startSession", updatedData);

      } catch (error) {
        console.error("Error --------", error);
        setIsLoading(false);

        const errorText = error.message.includes("Failed to fetch")
          ? "Network error: Unable to connect to the server. Please reload the page to start the chat again"
          : error.message.includes("Invalid response")
            ? "Server error: Received unexpected response format. Please reload the page to start the chat again"
            : "Sorry, I'm having trouble understanding that. Please reload the page to start the chat again";

        const errorMessage = {
          sender: "assistant",
          text: errorText,
          citations: [],
          relevantLinks: [],
          disclaimerText: "",
          documents: [],
          followUps: [],
        };
        setConversation((prevMessages) => {
          const newMessages = [...prevMessages];
          newMessages[newMessages.length - 1] = errorMessage;
          return newMessages;
        });
      }
    }
  };

  const handleFeedbackSubmit = async (index, type) => {
    if (submittingFeedback) {
      return;
    }
    setSubmittingFeedback(true);
    try {
      let chatbotDetails = encrypted.getDecryptedItem(
        "chatbotDetails");
      const rating = type;
      let sessionData = encrypted.getDecryptedItem(
        "startSession");
      const userId = sessionData?.user_id || "";
      const sessionId = sessionData?.session_id || "";
      const queryIndex = Math.floor(Number(index) / 2);

      let requestBody = {
        "user_id": userId,
        "session_id": sessionId,
        "temperature": chatbotDetails?.user_session?.temperature,
        "top_p": chatbotDetails?.user_session?.top_p,
        "search_index": chatbotDetails?.user_session?.search_index,
        "embedding_name": chatbotDetails?.user_session?.embedding_name,
        "search_strictness": chatbotDetails?.user_session?.search_strictness,
        "search_top_k": chatbotDetails?.user_session?.search_top_k,
        "max_tokens": chatbotDetails?.user_session?.max_tokens,
        "model_name": chatbotDetails?.user_session?.model_name,
        "api_version": chatbotDetails?.user_session?.api_version,
        "search_service": chatbotDetails?.user_session?.search_service,
        "tipo_chat": chatbotDetails?.user_session?.tipo_chat,
        "idioma_3l": chatbotDetails?.user_session?.idioma_3l,
        "language": chatbotDetails?.user_session?.language,
        "country": chatbotDetails?.user_session?.country,
        "queries": chatbotDetails?.user_session?.queries,
        "responses": chatbotDetails?.user_session?.responses,
        "feedback": JSON.stringify(rating),
        "feedback_comment": chatbotDetails?.user_session?.feedback_comment,
        "message_index": queryIndex,
      };
      await dispatch(postFeedback(`${env.baseURL}/update-feedback-chat`, requestBody));
      toast.success(feedbackSuccessText);
      setFeedbackData((prevFeedback) => ({
        ...prevFeedback,
        [index]: { type: "", comment: "" },
      }));
      setShowFeedbackInput(type === "dislike"); // Keep the popup open if dislike
    } catch (error) {
      console.error("Feedback submission error:", error);
      toast.error(feedbackFailureText);
    } finally {
      setSubmittingFeedback(false);
    }
  };
  const [conversation, setConversation] = useState(() => {
    const savedConversation = encrypted.getDecryptedItem("conversation");
    return savedConversation ? savedConversation : [];
  });

  useEffect(() => {
    const popupCheck = encrypted.getDecryptedItem(
      "isFeedbackPopupClosed")
    const feedbackSubmitted = encrypted.getDecryptedItem("feedbackSubmitted");
    if (!isLoading && conversation.length === 20 && !popupCheck && !feedbackSubmitted) {
      checkFeedbackPopup();
    }
    // eslint-disable-next-line
  }, [conversation, isLoading, dispatch]);

  useEffect(() => {
    if (conversation.length > 0) {
      encrypted.setEncryptedItem(
        "conversation", conversation); // Save conversation to localStorage on update
    }
  }, [conversation]);

  const handleCloseFeedbackPopup = () => {
    setShowPopup(false);
    setIsFeedbackPopupClosed(true);
    encrypted.setEncryptedItem(
      "isFeedbackPopupClosed", "true");
  };


  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pdfPreviewRef.current && !pdfPreviewRef.current.contains(event.target)) {
        handleCloseCitationModal(); // Close the PDF preview
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [pdfPreviewRef]);

  useEffect(() => {
    if (showFeedbackInput && feedbackInputRef.current) {
      feedbackInputRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [showFeedbackInput]);

  const openCardsPopup = () => {
    setIsModalOpen(true);
  }

  const handleKeyPress = (event) => {
    if (isMobile) {
      return;
    }
    if (event.key === "Enter") {
      if (event.shiftKey) {
        event.preventDefault();
        const { selectionStart, selectionEnd, value } = event.target;
        const newValue = value.slice(0, selectionStart) + "\n" + value.slice(selectionEnd);
        setUserInput(newValue);
        requestAnimationFrame(() => {
          event.target.selectionStart = event.target.selectionEnd = selectionStart + 1;
        });
      } else {
        event.preventDefault();
        handleSubmitQuery();
      }
    }
  };
  const handleKeyPressFeedback = (event) => {
    if (event.key === "Enter") {
      const textarea = event.target;
      const { selectionStart, selectionEnd } = textarea;
      if (event.shiftKey) {
        // Shift+Enter - insert new line
        event.preventDefault();
        const currentComment = feedbackInput[currentFeedbackIndex]?.comment || "";
        const beforeCursor = currentComment.slice(0, selectionStart);
        const afterCursor = currentComment.slice(selectionEnd);
        const newComment = beforeCursor + "\n" + afterCursor;

        setFeedbackInput((prevFeedback) => ({
          ...prevFeedback,
          [currentFeedbackIndex]: {
            ...prevFeedback[currentFeedbackIndex],
            comment: newComment,
          },
        }));
        requestAnimationFrame(() => {
          textarea.selectionStart = textarea.selectionEnd = selectionStart + 1;
        });
      } else {
        event.preventDefault();
        if (feedbackInput[currentFeedbackIndex]?.comment?.trim()) {
          updateFeedbackComment(currentFeedbackIndex);
        }
      }
    }
  };
  const handleCheckScroll = () => {
    if (chatContainerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = chatContainerRef.current;
      const isAtBottom = scrollHeight - scrollTop - clientHeight < 100;
      setShowScrollButton(!isAtBottom);
    }
  };

  useEffect(() => {
    const container = chatContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleCheckScroll);
      return () => container.removeEventListener("scroll", handleCheckScroll);
    }
  }, []);

  useEffect(() => {
    handleCheckScroll();
  }, [conversation]);

  const scrollToBottom = () => {
    if (conversationRef.current) {
      conversationRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  const handleCardClick = (text) => {
  setUserInput(text);
  setIsSample(true);
};

  const handleClearChat = async () => {
    setConversation([]);
    setQueries([]);
    setResponses([]);

    // Clear local storage
    localStorage.removeItem("conversation");
    localStorage.removeItem("queries");
    localStorage.removeItem("responses");
    localStorage.removeItem("chatbotDetails");
    localStorage.removeItem("feedbackButtonsDisabled");
    localStorage.removeItem("showFeedback");

    setUserInput("");
    setShowClearChatModal(false);
    setFeedbackData({});
    setSelectedFeedback({});
    setShowFeedback(false);
    setShowFeedbackInput(false);
    setCurrentFeedbackIndex(null);
    setFeedbackInput({});
    setFeedbackButtonsDisabled({});
    await startSession();
  }

  return (
    <div className={`main-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
      <Navbar />
      <ToastContainer closeButton={true} position="top-right" />

      <div className="chat-description" ref={chatContainerRef} >
        <div className="chat-info-container container-center" >
          <header className={`chatnpp-header ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <span>{chatWelcomeText}</span>
            <p>
              {chatIntroText}
            </p>
          </header>
          <section className={`expertise-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
            <h3>{expertiseTitleText}</h3>
            <div className="expertise-tags">
              {[
                nppProductsText,
                agriculturalBiotechnologyText,
                microbiologyText,
                plantScienceText,
                soilScienceText,
                agronomyText,
                environmentalScienceText,
              ].map((tag, index) => (
                <span key={index} className={`tag ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                  {tag}
                </span>
              ))}
            </div>
          </section>
          <section className={`capabilities-section ${isDarkMode ? "dark-mode" : "light-mode"}`}>
            <h3>{descriptionText}</h3>
            {isCardsLoading &&
              // Loader while waiting
              <div className="container-center">
                <div className="spinner-loader"></div>
              </div>}
                <div className="capabilities-grid">
                  {capabilities?.map((item, index) => {
                    return (
                      <button
                        key={index}
                        className={`capability-card container-start ${isDarkMode ? "dark-mode" : "light-mode"}`}
                        onClick={() => handleCardClick(item.text)}
                      >
                        <h2>{item.title}</h2>
                        <p>{item.text}</p>
                      </button>
                    );
                  })}
                </div>
                <button className="capability-view-card button-style fs-14" onClick={() => openCardsPopup()}>
                  {viewMore}
                </button>
              </section>
        </div>

        <div className="conversation-wrapper">
          <div className="conversation-container">
            {conversation.map((message, index) => (
              <div
                key={index}
                className={`message ${message.sender === "user" ? "user-message" : "assistant-message"}`}>
                <div className="message-content">
                  {message.sender === "user" ? (
                    <div className="user-icon-chat">
                      {userName ? userName.charAt(0).toUpperCase() : "U"}
                    </div>
                  ) : (
                    <img
                      src={chatLogo}
                      alt={`${message.sender}-icon`}
                      className="message-icon"
                    />
                  )}
                  <MessageComponent
                    message={message}
                    handleCitationClick={handleCitationClick}
                  />

                  {message.sender === "assistant" && showFeedback && (
                    <div className="feedback-prompt">
                      <div className="feedback-row" ref={feedbackButtonsRef}>
                        <div className="feedback-buttons">
                          <button
                            className={`like-button ${feedbackButtonsDisabled[index] ? 'disabled' : ''}`}
                            onClick={() => handleFeedback(index, "like")}
                            disabled={feedbackButtonsDisabled[index]}
                          >
                            <img
                              src={selectedFeedback[index] === "like"
                                ? (isDarkMode ? likeSelectedDark : likeSelected)
                                : (isDarkMode ? likeDark : like)}
                              alt="like-image" />
                          </button>
                          <button
                            className={`dislike-button ${feedbackButtonsDisabled[index] ? 'disabled' : ''}`}
                            onClick={() => handleFeedback(index, "dislike")}
                            disabled={feedbackButtonsDisabled[index]}
                          >
                            <img src={selectedFeedback[index] === "dislike" ? (isDarkMode ? dislikeSelectedDark : dislikeSelected)
                              : (isDarkMode ? dislikeDark : dislike)} alt="dislike-image" />
                          </button>
                        </div>
                      </div>
                      {showFeedbackInput && currentFeedbackIndex === index && (
                        <div ref={feedbackContainerRef} className={`additional-feedback ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                          <div className="feedback-input-area">
                            <textarea
                              ref={feedbackInputRef}
                              className={`feedback-input ${isDarkMode ? 'dark-mode' : 'light-mode'}`}
                              value={feedbackInput[index]?.comment || ""}
                              onChange={handleFeedbackCommentChange}
                              placeholder={feedbackPrompt}
                              onKeyDown={handleKeyPressFeedback}
                              style={{
                                resize: "none",
                                overflowY: "auto"
                              }}
                              maxLength={5000}
                            />
                          </div>
                          {isTypingFeedback && <div className={`apply-feedback ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>{feedbackSubmit}</div>}
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))}
            {openDoc && (
              <div ref={pdfPreviewRef}
              >
                <PdfPreview
                  onClose={closeModal}
                  isOpen={openModal}
                  fileName={fileName}
                  pdfUrlFile={citationModalContent.url}
                />
              </div>
            )}

            <div ref={conversationRef}></div>
          </div>
        </div>
      </div>
      {showScrollButton &&
        <button type="button" className="button-style scroll-to-bottom" onClick={scrollToBottom}>
          <img src={dropDownIcon} alt="dropDownIcon" />
        </button>
      }
      <div className={`footer-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
        <div className="footer">
          <div className="footer-actions">
            <div className="left-actions container-center">
              {conversation.length > 0 && !isLoading && (
                <button className="clear-chat" onClick={() => setShowClearChatModal(true)}>
                  <img
                    src={isDarkMode ? clearChatDark : trash}
                    alt="Delete Icon"
                    className="delete-icon"
                  />
                  <span className={`delete-chat-message ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                    {clearChatText}
                  </span>
                </button>
              )}

              {!isMobile && (
                <div className={`note-section ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                  <div className="heading">
                    <span className="text">{commandText}</span>
                  </div>
                </div>
              )}
            </div>
            {conversation.length > 0 && !isLoading && (
              <button className="prompt-info container-end fs-14" onClick={() => openCardsPopup()}>
                <span className={`prompt-info-example ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
                  {promptExamplesText}
                </span>
              </button>
            )}
          </div>


          <ClearChatModal
            show={showClearChatModal}
            handleClearChat={handleClearChat}
            handleClose={() => setShowClearChatModal(false)}
            translations={translations}
          />
        </div>

        <div className={`input-container ${isDarkMode ? 'dark-mode' : 'light-mode'}`}>
          <textarea
            className={`input-box ${isLoading ? "disabled" : ""}`}
            value={userInput}
            onChange={handleInputChange}
            onKeyDown={handleKeyPress}
            placeholder={questionText}
            rows="3"
            style={{
              resize: "none",
              color: isDarkMode ? "rgba(255, 255, 255, 0.7)" : "black"
            }}
            disabled={isLoading}
            maxLength={20000}
          ></textarea>
          <button
            className={`output-arrow ${isLoading || !userInput.trim() ? "disabled" : ""}`}
            onClick={handleSubmitQuery}
            disabled={isLoading || !userInput.trim()}
          >
            <img src={outputArrow} alt="arrow-icon" />
          </button>
        </div>
        {!isFeedbackPopupClosed && showPopup && (
          <FeedbackPopup onClose={handleCloseFeedbackPopup} />
        )}
      </div>
      <PromptExamplesModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelectPrompt={(selectedText) => {
          setUserInput(selectedText);
          setIsSample(true);
        }}
      />
    </div>
  );
};


export default Chat;

const ClearChatModal = ({ show, handleClearChat, handleClose, translations }) => {

  if (!show) return null;
  const clearChatText = translations["clear_chat_text"] || "Clear Chat";
  const clearChatConfirm = translations["clear_chat_confirm"] || "Are you sure you want to clear the chat?";
  const logoutYes = translations["logout_yes"] || "Yes";
  const logoutNo = translations["logout_no"] || "No";


  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="logout-icon">
          <img src={clearChat} alt="Logout Icon" />
          <span className="logout-header">{clearChatText}?</span>
        </div>
        <div className="logout-text">
          {clearChatConfirm}
        </div>
        <div className="modal-buttons">
          <button onClick={handleClearChat} className="yes-btn">{logoutYes}</button>
          <button onClick={handleClose} className="no-btn">{logoutNo}</button>
        </div>
      </div>
    </div>
  );
};
